import React from 'react';
import { FaRegWindowMinimize } from 'react-icons/fa';

export default function AudioPlayerHeadWindowActions({ onMinimize = null, onClose = null }) {
  if (!onMinimize && !onClose) return null;

  return (
    <>
      {onMinimize ? (
        <button
          type="button"
          className="audio-player__head-action-btn audio-player-window-minimize-btn"
          onClick={onMinimize}
          aria-label="Minimize player"
          title="Minimize"
        >
          <FaRegWindowMinimize aria-hidden />
        </button>
      ) : null}
      {onClose ? (
        <button
          type="button"
          className="audio-player__head-action-btn audio-player__head-action-btn--close"
          onClick={onClose}
          aria-label="Close audio player"
          title="Close"
        >
          <span aria-hidden>×</span>
        </button>
      ) : null}
    </>
  );
}
